export const pricingData = [
  {
    category: 'Psychiatria',
    items: [
      {
        title: 'Konsultacja psychiatryczna – pierwsza wizyta',
        description: 'Diagnoza i ocena kliniczna',
        price: '350 – 500 zł',
      },
      {
        title: 'Konsultacja psychiatryczna – kolejna wizyta',
        description: 'Monitoring i leczenie farmakologiczne',
        price: '300 – 450 zł',
      },
      {
        title: 'Wizyta recepturowa',
        description: 'Wystawienie recepty bez konsultacji',
        price: '130 zł',
      },
      {
        title: 'Zaświadczenie lekarskie',
        description: 'Wystawienie zaświadczenia o stanie zdrowia',
        price: '250 zł',
      },
    ],
  },
  {
    category: 'Psychologia',
    items: [
      {
        title: 'Konsultacja psychologiczna',
        description: 'Jednostkowa porada psychologa',
        price: '180 zł',
      },
      {
        title: 'Psychoterapia indywidualna',
        description: 'Cena zależy od certyfikacji specjalisty',
        price: '180 – 200 zł',
      },

      {
        title: 'Konsultacja kwalifikująca do psychoterapii',
        description: 'Ocena przydatności i planu terapii',
        price: '200 zł',
      },
      {
        title: 'Psychologia rodzinna – terapia rodzin',
        description: 'Sesja dla całej rodziny',
        price: '290 zł',
      },
      {
        title: 'Terapia par',
        description: 'Sesja dla pary',
        price: '260 zł',
      },
    ],
  },
  {
    category: 'Opinie i badania',
    items: [
      {
        title: 'Opinia psychologiczna PZdsOoN',
        description: 'Dla potrzeb orzeczenia o niepełnosprawności',
        price: '400 zł',
      },
      {
        title: 'Opinia psychologiczna ZUS',
        description: 'Dla potrzeb ubezpieczenia społecznego',
        price: '600 zł',
      },
      {
        title: 'Opinia psychologiczna u pacjenta w domu',
        description: 'Wykonanie opinii w miejscu zamieszkania',
        price: '600 – 800 zł',
      },
      {
        title: 'Badanie psychologiczne z opisem i testem',
        description: 'Diagnoza neuropsychologiczna i poznawcza',
        price: '350 – 800 zł',
      },
    ],
  },
  {
    category: 'Terapia sensoryczna',
    items: [
      {
        title: 'Terapia integracji sensorycznej – 50 min',
        description: 'Sesja indywidualna',
        price: '160 zł',
      },
      {
        title: 'Terapia integracji sensorycznej – grupa 2-osobowa',
        description: 'Zajęcia w małej grupie',
        price: '200 zł',
      },
      {
        title: 'Diagnoza zaburzeń integracji sensorycznej',
        description: 'Pełna ocena funkcji sensorycznych',
        price: '600 zł',
      },
    ],
  },
  {
    category: 'Logopedia',
    items: [
      {
        title: 'Diagnoza logopedyczna',
        description: 'Ocena umiejętności mowy i komunikacji',
        price: '400 zł',
      },
      {
        title: 'Diagnoza dziecka z zaburzeniami integracji sensorycznej',
        description:
          'Kompleksowa ocena funkcjonowania sensorycznego dziecka wraz z zaleceniami terapeutycznymi',
        price: '600 zł',
      },
      {
        title: 'Terapia logopedyczna',
        description: 'Sesja logopedy dla dziecka lub dorosłego',
        price: '130 zł (50 min) / 90 zł (30 min)',
      },
    ],
  },
];
